import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchNotificationReadAll } from "apis/notification";
import QUERY_KEYS from "config/queryKey";

const useNotificationReadAllMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchNotificationReadAll,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.notifications] });
    },
  });
};

export default useNotificationReadAllMutation;
